module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_cd_dvd_d353394afaef95fe88c8f30e07d5ea53.png";